module.exports = __webpack_public_path__ + "img/wobi2.be242383.png";